<div class="row">
    <div class="col-lg-12 col-xl-8 offset-xl-2">

        <form [formGroup]="form" autocomplete="off" novalidate [autocomplete]="'off'" (ngSubmit)="onSubmit()">

            <h3 class="mb-30">Primary Contact Details</h3>
            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">First Name</label>
                <div class="col-12 col-sm-9">
                    <input
                        [ngClass]="{'is-invalid' : form['controls'].firstname.invalid && form['controls'].firstname.touched}"
                        type="text" class="form-control bordered" formControlName="firstname" placeholder="First name">
                    <div class="invalid-feedback">First name is required</div>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Last Name</label>
                <div class="col-12 col-sm-9">
                    <input
                        [ngClass]="{'is-invalid' : form['controls'].surname.invalid && form['controls'].surname.touched}"
                        type="text" class="form-control bordered" formControlName="surname" placeholder="Last name">
                    <div class="invalid-feedback">Surname is required</div>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Job Title</label>
                <div class="col-12 col-sm-9">
                    <input type="text" class="form-control bordered" formControlName="jobTitle" placeholder="Job Title">
                </div>
            </div>


            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Email Address</label>
                <div class="col-12 col-sm-9">
                    <input [ngClass]="{'is-invalid' : form['controls'].email.invalid && form['controls'].email.touched}"
                        type="email" autocomplete="new-password" class="form-control bordered" formControlName="email"
                        placeholder="Email">
                    <div class="invalid-feedback">Enter a valid email</div>
                    <div style="padding-top: 10px">
                        <i class="">This email will also be used when logging in</i>
                    </div>
                </div>
            </div>

            <div class="mb-3 row">
                <label class="col-sm-3 col-form-label">Telephone Number</label>
                <div class="col-12 col-sm-9">
                    <ys-phone-input formControlName="mobile"></ys-phone-input>
                </div>
            </div>

            <div style="padding-top: 10px; padding-bottom: 30px">
                <div class="row">
                    <label class="col-sm-3 col-form-label"></label>
                    <div class="col-12 col-sm-9">
                        <a (click)="toggleValue('marketing')">
                            <i class="far fa-check-square" *ngIf="user.marketing"></i>
                            <i class="far fa-square" *ngIf="!user.marketing"></i>
                            Subscribe to receive marketing emails
                        </a>

                    </div>
                </div>
                <div class="row">
                    <label class="col-sm-3 col-form-label"></label>
                    <div class="col-12 col-sm-9">
                        <a (click)="toggleValue('terms')">
                            <i class="far fa-check-square" *ngIf="user.terms"></i>
                            <i class="far fa-square" *ngIf="!user.terms"></i>
                            Confirm terms and conditions
                        </a>

                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-6">
                </div>
                <div class="col-6 text-end">
                    <button [disabled]="!form.valid" type="submit" class="btn btn-round btn-primary">
                        Continue
                    </button>
                </div>
            </div>
            <div class="mt-2 text-center" *ngIf="entryType === 'jobLot'">
                <p class="alert alert-danger">After clicking 'Continue' you will be returned to the product setup routine</p>
            </div>

            <div class="mt-2 text-end" *ngIf="entryType !== 'jobLot'">
                <p>Supplier / user data will be saved upon clicking 'Continue'</p>
            </div>
        </form>

    </div>
</div>
